import React, { useEffect, useState } from 'react'
import { Link,  Outlet } from 'react-router-dom'
import ButtonPlus from '../SelectValue/ButtonPlus'
import ProjectCom from './ProjectCom'
import Sections from './Sections'
import getServices from '../../Services/get-service'

import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';

import Select, { SelectChangeEvent } from '@mui/material/Select';

function MainPage() {
    const [active, setActive] = useState("0")
    const [pending, setPending] = useState('0')
    const [complected, setCompleted] = useState('0')


    useEffect(() =>{
            getServices.getAllCount().then(
                (response) => {
                   
                  if(response.data.status === "2000"){
                    setActive(response.data.data.totalSumActiveProject)
                    setPending(response.data.data.totalPendingProject)
                    setCompleted(response.data.data.totalSumCompletedProject)
                  }else{
                  //  swal(response.data.description)
                  //  toast('Session Expired', {
                  //   onClose: () => {
                  //       window.location.href = '/'
                  //   },
                  //   autoClose: 5000
                  // })
                  }
                  console.log(response.data.data)
                },
                (error) => {
                   
                }
            )
    }, [])
  return (
    <div>

    <Link to='newproject/projectdetails'>
    <ButtonPlus
            name='Add new Asset'
           
        />
    </Link>
       
        
        <div >

        <div className='flex flex-row justify-between my-8 gap-4'>
            <input placeholder='Search by name or email address' className='border border-gray-300 focus:border-primary-color outline-none p-2 rounded-lg w-2/5'
            />

            {/* <input placeholder='status' className='border border-gray-300 focus:border-primary-color outline-none p-2 rounded-lg w-80'
            /> */}

                    <FormControl  className='w-60 border' >
                        <InputLabel  id="demo-simple-select-label">Asset category</InputLabel>
                        <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        // value={age}
                        // label="Age"
                        // onChange={handleChange}
                        >
                        <MenuItem value={'Electronics'}>Electronics</MenuItem>
                        
                        </Select>
                    </FormControl>

            {/* <input placeholder='date added' className='border border-gray-300 focus:border-primary-color outline-none p-2 rounded-lg w-60'
            /> */}

                    <FormControl className='w-60' >
                        <InputLabel id="demo-simple-select-label">Date added</InputLabel>
                        <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        // value={age}
                        // label="Age"
                        // onChange={handleChange}
                        >
                        <MenuItem value={10}>This week</MenuItem>
                        <MenuItem value={20}>This month</MenuItem>
                        <MenuItem value={30}>This year</MenuItem>
                        </Select>
                    </FormControl>

            {/* <input placeholder='Asset category' className='border border-gray-300 focus:border-primary-color outline-none p-2 rounded-lg w-60'
            /> */}

                <FormControl className='w-60' >
                        <InputLabel id="demo-simple-select-label">Status</InputLabel>
                        <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        // value={age}
                        // label="Age"
                        // onChange={handleChange}
                        >
                        <MenuItem value={'in stock'}>in stock</MenuItem>
                        <MenuItem value={'out of stock'}>out of stock</MenuItem>
                      
                        </Select>
                    </FormControl>
        </div>


        <div className='flex flex-row justify-between gap-2 my-5'>
                <div className='border-2 w-1/2 rounded-lg border-gray-200 p-3' >
                             <p>Total Assets</p>
                    <p className='font-semibold'>200</p>

                </div>

                <div className='border-2 w-1/2 rounded-lg border-gray-200 p-3' >
                
                    <p>Asset sold</p>
                    <p className='font-semibold'>200</p>

                </div> 
                
                 <div className='border-2 w-1/2 rounded-lg border-gray-200 p-3' >
                    <p>Asset amount sold</p>
                    <p className='font-semibold'>200</p>

                </div>

                <div className='border-2 w-1/2 rounded-lg border-gray-200 p-3' >
                  <p>Asset amount paid</p>
                  <p className='font-semibold'>200</p>

                </div>

                <div className='border-2 w-1/2 rounded-lg border-gray-200 p-3' >
                    <p>Asset amount outstanding</p>
                    <p className='font-semibold'>200</p>

                </div>

            </div>

        
        </div>
        <div className=' mt-10'>
            <Sections/>
            <Outlet/>
        </div>
    </div>
  )
}

export default MainPage